import EventEmitter from 'events';

export default class HashController extends EventEmitter {
  constructor() {
    super();

    this._setValue = null;

    this._listener = this._handler.bind(this);
    window.addEventListener('hashchange', this._listener);
  }

  _handler() {
    if (window.location.hash === this._setValue) {
      return;
    }

    this.emit('change', window.location.hash);
  }

  set(hash) {
    this._setValue = '#' + hash;

    window.location.hash = hash;
  }
}
